import { EventEmitter } from '@angular/core';
var FcListItemComponent = /** @class */ (function () {
    function FcListItemComponent() {
        this.disabled = false;
        this.selectedChange = new EventEmitter();
    }
    FcListItemComponent.prototype.onCheckboxChange = function (event) {
        this.item.selected = event.checked;
        this.selectedChange.emit(this.item);
    };
    return FcListItemComponent;
}());
export { FcListItemComponent };
